<template>
  <fieldset class="sp-fieldset">
    <slot name="legend" class="sp-fieldset__legend">
      <legend v-if="legend" part="legend">
        {{ legend }}
      </legend>
    </slot>
    <sp-container v-preserve-properties:rowgap="rowgap" class="content" :flex="flex" :direction="direction">
      <slot />
    </sp-container>
  </fieldset>
</template>

<script setup>
import { vPreserveProperties } from "#ce/utils/property-bindings";
import { props as fieldsetProps } from "./props.js";
defineProps(fieldsetProps);
</script>

<style>
:host {
  display: block;
  width: 100%;
  max-width: 100%;
}
</style>

<style scoped lang="scss">
.sp-fieldset {
  border: 0;
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: 100%;
}
</style>
